<template>
  <WorkflowStep :step="step" :tab-data="scenarioTabs" />
</template>

<script>
import toolbarTab from '@/utils/tabs/toolbar-tabs-enum';
import scenarioTabs from '@/utils/tabs/scenario-tabs-enum';

export default {
  data() {
    return {
      step: toolbarTab.MEASURING_TAB,
      scenarioTabs,
    };
  },
};
</script>

<style lang="scss"></style>
